import { render, staticRenderFns } from "./Usages.vue?vue&type=template&id=64021ab9&"
import script from "./Usages.vue?vue&type=script&lang=ts&"
export * from "./Usages.vue?vue&type=script&lang=ts&"
import style0 from "./Usages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports